<template>
  <div class="products-chip-filter">
    <div class="products-chip-head">
      <b-icon icon="folder"></b-icon>
      <strong>دسته‌بندی</strong>
      <input class="products-chip-search" v-model="searchedWord" placeholder="جستجوی دسته">
    </div>
    <div class="products-chip-selected" v-if="selectedCategory.length">
      <button
        v-for="(item, index) in selectedCategory"
        :key="'sel-' + item.id"
        type="button"
        class="products-chip is-on"
        @click="removeCategory(index)"
      >
        {{ item.name }} ×
      </button>
    </div>
    <div class="products-chip-tree">
      <category
        :remove-category="removeCategory"
        :selected-category="selectedCategory"
        :margin="0"
        v-for="categoryItem in searchedCategory"
        :key="categoryItem.id"
        :category="categoryItem"
      />
    </div>
  </div>
</template>

<script>
import category from "../../category.vue";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";

export default {
  name: "Category",
  components: {category},
  data() {
    return {
      categories: [],
      selectedCategory: [],
      searchedWord: '',
      ready: false,
    }
  },
  computed: {
    searchedCategory() {
      if (!this.searchedWord.length) {
        return this.categories
      }
      return flatCategories(this.categories)
        .filter(item => (item.name || '').indexOf(this.searchedWord) > -1)
        .map(item => ({...item, children: []}))
    }
  },
  methods: {
    removeCategory(index) {
      this.selectedCategory.splice(index, 1);
    },
    applyFilter() {
      if (!this.ready) {
        return
      }
      this.$store.commit("Product/setFilters", {key: "category", value: this.selectedCategory.map(item => item.id)});
      this.$emit('updateFilter', {category: this.selectedCategory})
      this.$store.dispatch("Product/setDashboardProducts", 1);
    }
  },
  async mounted() {
    const queryValue = this.$route.query.category;
    const queryIds = queryValue != undefined ? String(queryValue).split(',').filter(Boolean) : []
    if (queryIds.length) {
      this.$store.commit('Product/setFilters', {key: 'category', value: queryIds})
    }

    const response = await this.$store.dispatch('Category/getDashboardCategoriesWithoutState')
    this.categories = (response && response.data && response.data.data) || []
    if (queryIds.length) {
      const flat = flatCategories(this.categories)
      this.selectedCategory = flat.filter(item => queryIds.indexOf(String(item.id)) > -1)
    }
    this.$nextTick(() => {
      this.ready = true
    })
  },
  watch: {
    selectedCategory: {
      deep: true,
      handler() {
        this.applyFilter()
      }
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "category", value: []});
  }
}
</script>
